/** Site Peter Diving */
'use strict';

if (!window.$site) {
	window.$site = {};
}

require('../components/cookies');
require('../components/fs-menu');
require('../components/header');
require('../components/welcome');
require('../components/peter-points');
require('../components/contact-form');
require('../components/fs-video');
require('../components/home-videos');
require('../components/home-clients');
require('../components/posts');
require('../components/over-label');
require('../components/faq');
require('../components/header-image');
